import {apiSlice} from './apiSlice';

// Define a service using a base URL and expected endpoints
export const referrerApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getReferrers: builder.query({
      query: filters => {
        const qs = Object.keys(filters).reduce((acc, k) => {
          acc.set(k, filters[k]);
          return acc;
        }, new URLSearchParams());
        return `referrer/?${qs}`;
      },
      providesTags: ['Referrer'],
    }),
    createReferrer: builder.mutation({
      query: body => ({
        url: 'referrer/',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Referrer'],
    })
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useCreateReferrerMutation,
  useGetReferrersQuery
} = referrerApi;
